<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-button class="mb-3" variant="danger" @click="goBack">Voltar</b-button>
    <b-card>
      <b-row>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Descrição:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>{{descricaoProduto}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Código de Barras:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>{{codBarras}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Quantidade Vendida:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>{{quantidadeVendida}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Valor Passado:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>R$ {{valorUn}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Total Vendido:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>R$ {{totalVendido}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-row>
            <b-col cols="6" class="fs-12">
              <strong>Valor Atual:</strong>
            </b-col>
            <b-col cols="6" class="fs-12">
              <span>R$ {{valorAtual}}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="renderizar">
      <b-row>
        <b-col>
          <div v-if="seriesProduto.length > 0">
            <div>
              <h4>
                <strong>Variação do produto</strong>
              </h4>
            </div>
            <apexchart type="area" height="350" :options="options" :series="series" />
          </div>
          <center v-else>
            <i class="fa fa-frown-o fa-custom-size"></i>
            <h4>Desculpe, não encontramos dados suficientes para montar o grafico de variação :(</h4>
          </center>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  components: {
    Loading
  },
  data: _ => {
    return {
      renderizar: false,
      descricaoProduto: null,
      quantidadeVendida: null,
      totalVendido: null,
      codBarras: null,
      valorUn: null,
      valorAtual: null,
      valorPromocional: null,
      categoriesProduto: null,
      seriesProduto: null,
      isLoading: false,
      options: {
        chart: {
          locales: [
            {
              name: "pt",
              options: {
                months: [
                  "Janeiro",
                  "Fevereiro",
                  "Março",
                  "Abril",
                  "Maio",
                  "Junho",
                  "Julho",
                  "Agosto",
                  "Setembro",
                  "Outubro",
                  "Novembro",
                  "Dezembro"
                ],
                shortMonths: [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez"
                ],
                days: [
                  "Domingo",
                  "Segunda",
                  "Terça",
                  "Quarta",
                  "Quinta",
                  "Sexta",
                  "Sábado"
                ],
                shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
                toolbar: {
                  exportToSVG: "Baixar SVG",
                  exportToPNG: "Baixar PNG",
                  menu: "Menu",
                  selection: "Seleção",
                  selectionZoom: "Zoom",
                  zoomIn: "Aproximar",
                  zoomOut: "Afastar",
                  pan: "Mover",
                  reset: "Resetar"
                }
              }
            }
          ],
          defaultLocale: "pt"
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        xaxis: {
          type: "datetime",
          tickAmount: 6
        },
        yaxis: {
          max: 1,
          min: 0,
          tickAmount: 6
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy"
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100]
          }
        },
        tooltip: {
          enabled: true,
          followCursor: true
        }
      },
      series: [
        {
          data: []
        }
      ]
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getVariacaoProduto() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/variacao-produto/${moment(
            localStorage.getItem("datainicial_compras")
          ).format("YYYY-MM-DD")}/${moment(
            localStorage.getItem("datafinal_compras")
          ).format("YYYY-MM-DD")}/${localStorage.getItem(
            "id_produto"
          )}/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.seriesProduto = [];
            var aux = 0;
            for (let i = 0; i < response.data.data.length; i++) {
              const e = response.data.data[i];
              this.seriesProduto.push([
                new Date(moment(e.data)).getTime(),
                e.valor != null && e.valor != undefined ? e.valor : this.valorUn
              ]);
              if (e.valor != null && e.valor != undefined) {
                if (e.valor > aux) aux = e.valor;
              } else {
                aux = this.valorUn;
              }
            }
            var arrAux = Math.trunc(aux)
              .toString()
              .split("");
            console.info(arrAux);
            if (arrAux.length == 1) {
              aux = Math.round(aux) + 1;
              this.options.yaxis.tickAmount = 4;
            } else if (arrAux.length == 2) {
              aux = Math.round(aux) + 10;
            } else if (arrAux.length == 3) {
              aux = Math.round(aux) + 100;
            }
            this.options.yaxis.max = aux;
            this.series = [
              {
                name: "Valor",
                data: this.seriesProduto
              }
            ];
          }
        });
      this.renderizar = true;
    }
  },
  async beforeMount() {
    this.isLoading = true;
    var dados = JSON.parse(localStorage.getItem("analise"));
    var codbarras = localStorage.getItem("id_produto");

    for (let i = 0; i < dados.produtos.length; i++) {
      const e = dados.produtos[i];
      if (codbarras == e.codbarras) {
        dados = e;
        break;
      }
    }

    this.descricaoProduto = dados.descricao;
    this.codBarras = dados.codbarras;
    this.quantidadeVendida = dados.qtdvendida;
    this.valorUn = dados.valorunitariovendido;
    this.totalVendido = dados.valortotalvendido;
    this.valorAtual =
      dados.valorpromocionalatualproduto > 0
        ? dados.valorpromocionalatualproduto
        : dados.valoratualproduto;

    await this.getVariacaoProduto();

    this.isLoading = false;
  }
};
</script>
